import { createUseStoreField } from "../../utils";

import { briefcaseSummarySlice } from "./reducer";

export const useOnDate = createUseStoreField(
  (state) => state.briefcaseSummary.onDate,
  briefcaseSummarySlice.actions.setOnDate
);
